import Model, { ApiFieldDefinition, apiToModelTransformer } from '@infinity/shared/models/base'
import { Api, JsonData } from '@infinity/shared/helpers/api'

export default class Results extends Model {
  protected fieldDefinition: ApiFieldDefinition = {
    [Api.IM]: {
      url: 'url',
      filename: 'filename',
      batchId: 'batchId'
    }
  }

  private url = ''
  private filename = ''
  private batchId = ''

  getUrl (): string {
    return this.url
  }

  setUrl (value: string) {
    this.url = value
  }

  getFilename (): string {
    return this.filename
  }

  setFilename (value: string) {
    this.filename = value
  }

  getBatchId (): string {
    return this.batchId
  }

  setBatchId (batchId: string) {
    this.batchId = batchId
  }

  fromApiTransformer (data: JsonData, api: Api): Results {
    apiToModelTransformer(this, data, this.fieldDefinition[api])

    return this
  }

  toApiTransformer (): undefined {
    return undefined
  }
}
